import React from 'react'
import { NativeLink } from './NativeLink'

export type LinkProps = {
  useNative?: boolean
  disabled?: boolean
} & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>

/**
 * This can be a wrapper for the the Link for react-router, or nextjs or even the native links
 * @param props
 * @constructor
 */
export const Link = (props: LinkProps) => {
  const useNative = props.useNative ?? true

  if (useNative) {
    return <NativeLink {...props} />
  }
}
